(() => {
  const FLAG_OPEN = 'nf_open_cart_after_reload';
  const STORE_KEY = 'nf_bundle_savings_map'; // { [bundleId]: {originalCents, finalCents, savingsCents, percentText, ts} }

  const log = (...a) => console.log('[NF BundleFix]', ...a);
  const sleep = (ms) => new Promise((r) => setTimeout(r, ms));

  log('LOADED', window.location.pathname);

  // ---------- helpers ----------
  function isBundlePage() {
    return !!document.querySelector('lb-bundle-builder');
  }

  async function getCart() {
    const r = await fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' });
    return r.json();
  }

  function getBundlesFromCart(cart) {
    const bundles = [];
    for (const it of cart?.items || []) {
      const bid = it?.properties?.__de_bundle_id;
      if (bid) bundles.push({ bundleId: bid, lineKey: it.key, title: it.title, linePrice: it.final_line_price });
    }
    return bundles;
  }

  function moneyToCents(text) {
    if (!text) return null;
    const cleaned = String(text).replace(/[^\d,.\-]/g, '').replace(',', '.');
    const n = parseFloat(cleaned);
    if (Number.isNaN(n)) return null;
    return Math.round(n * 100);
  }

  function formatEUR(cents) {
    const euros = (cents / 100).toFixed(2).replace('.', ',');
    return `${euros} €`;
  }

  function extractSavingsFromWidget() {
    const root = document.querySelector('lb-bundle-builder');
    if (!root) return null;

    const sub = root.querySelector('.lb-bb-bundle-sub-total-price-value .money')?.textContent;
    const fin = root.querySelector('.lb-bb-bundle-total-price-value .money')?.textContent;
    const pct = root.querySelector('.lb-bb-bundle-save-text')?.textContent?.trim() || '';

    const originalCents = moneyToCents(sub);
    const finalCents = moneyToCents(fin);
    if (originalCents == null || finalCents == null) return null;

    return {
      originalCents,
      finalCents,
      savingsCents: Math.max(0, originalCents - finalCents),
      percentText: pct,
      ts: Date.now(),
    };
  }

  function openDrawer() {
    const toggle =
      document.querySelector('[aria-controls="CartDrawer"]') ||
      document.querySelector('[data-open-cart-drawer]');
    if (toggle && typeof toggle.click === 'function') toggle.click();
  }

  function ensureStyles() {
    if (document.getElementById('nf-bundle-savings-style')) return;
    const style = document.createElement('style');
    style.id = 'nf-bundle-savings-style';
    style.textContent = `
      .nf-bundle-savings-wrap{
        width:100%!important;
        display:block!important;
        box-sizing:border-box!important;
        margin:10px 0 12px 0!important;
      }
      .nf-bundle-savings{
        width:100%!important;
        box-sizing:border-box!important;
        padding:10px 12px!important;
        border-radius:10px!important;
        background:#f3f7f2!important;
        font-size:14px!important;
        line-height:1.3!important;
      }
      .nf-bundle-savings .nf-title{font-weight:600!important}
      .nf-bundle-savings .nf-line{margin-top:4px!important}
      .nf-bundle-savings .nf-muted{opacity:.75!important}
      .nf-bundle-savings .nf-strong{font-weight:700!important}
      .nf-bundle-savings .nf-chip{
        display:inline-block;
        font-size:12px;
        padding:2px 8px;
        border-radius:999px;
        background:rgba(0,0,0,.06);
        margin-left:6px;
        vertical-align:middle;
      }
    `;
    document.head.appendChild(style);
  }

  function loadSavingsMap() {
    try {
      const raw = sessionStorage.getItem(STORE_KEY);
      if (!raw) return {};
      const map = JSON.parse(raw);
      return map && typeof map === 'object' ? map : {};
    } catch {
      return {};
    }
  }

  function saveSavingsMap(map) {
    try {
      sessionStorage.setItem(STORE_KEY, JSON.stringify(map));
    } catch {}
  }

  function removeSavingsBox(drawer) {
    drawer.querySelectorAll('.nf-bundle-savings-wrap').forEach((n) => n.remove());
  }

  function findDrawer() {
    return (
      document.querySelector('#CartDrawer') ||
      document.querySelector('cart-drawer') ||
      document.querySelector('[data-cart-drawer]')
    );
  }

  // Inserta descuentos SOLO para bundles que existan ahora en el carrito
  async function syncDiscountBoxWithCart({ force = false } = {}) {
    ensureStyles();

    const drawer = findDrawer();
    if (!drawer) return false;

    // Si no forzamos y ya está, igual hay que actualizar si han borrado bundle, así que seguimos.

    let cart;
    try {
      cart = await getCart();
    } catch (e) {
      // Si falla cart.js, no tocamos nada para no hacer parpadeos raros
      return false;
    }

    const bundles = getBundlesFromCart(cart);
    const bundleIdsInCart = new Set(bundles.map((b) => b.bundleId));

    const map = loadSavingsMap();

    // Limpieza: si ya no existe el bundle en el carrito, lo borramos del map
    for (const bid of Object.keys(map)) {
      if (!bundleIdsInCart.has(bid)) delete map[bid];
    }
    saveSavingsMap(map);

    // Si no hay bundles ahora, quitamos bloque y listo
    if (bundleIdsInCart.size === 0) {
      removeSavingsBox(drawer);
      return true;
    }

    // Construimos bloques para cada bundle presente y con datos guardados
    const rows = [];
    let totalSaved = 0;

    for (const bid of bundleIdsInCart) {
      const data = map[bid];
      if (!data || typeof data.savingsCents !== 'number' || data.savingsCents <= 0) continue;

      totalSaved += data.savingsCents;

      rows.push(`
        <div class="nf-line">
          <span class="nf-strong">Ahorras ${formatEUR(data.savingsCents)}</span>
          ${data.percentText ? `<span class="nf-chip">${data.percentText}</span>` : ''}
        </div>
        <div class="nf-line">
          Antes: <span class="nf-muted" style="text-decoration:line-through;">${formatEUR(data.originalCents)}</span>
          &nbsp;Ahora: <span class="nf-strong">${formatEUR(data.finalCents)}</span>
        </div>
      `);
    }

    // Si por lo que sea hay bundles pero no tenemos datos (caso raro), quitamos el bloque
    if (rows.length === 0) {
      removeSavingsBox(drawer);
      return true;
    }

    // Evitar duplicados
    removeSavingsBox(drawer);

    const wrap = document.createElement('div');
    wrap.className = 'nf-bundle-savings-wrap';

    const box = document.createElement('div');
    box.className = 'nf-bundle-savings';
    box.innerHTML = `
      <div class="nf-title">🎉 Ahorro de tus packs</div>
      ${bundleIdsInCart.size > 1 ? `<div class="nf-line"><span class="nf-strong">Ahorro total: ${formatEUR(totalSaved)}</span></div>` : ''}
      ${rows.join('<div style="height:8px"></div>')}
    `;

    wrap.appendChild(box);

    // Ancla ultra estable: encima de botones “Ver carrito / Pasar por caja”
    const buttons = [...drawer.querySelectorAll('a,button')];
    const btnViewCart = buttons.find((el) => (el.textContent || '').trim().toLowerCase() === 'ver carrito');
    const btnCheckout = buttons.find((el) => (el.textContent || '').trim().toLowerCase() === 'pasar por caja');
    const anchorBtn = btnViewCart || btnCheckout;

    if (anchorBtn && anchorBtn.parentElement) {
      anchorBtn.parentElement.insertAdjacentElement('beforebegin', wrap);
      return true;
    }

    drawer.appendChild(wrap);
    return true;
  }

  // Reintentos (por si Breath tarda en renderizar)
  function syncWithRetries({ force = false } = {}) {
    let tries = 0;
    const t = setInterval(() => {
      tries++;
      syncDiscountBoxWithCart({ force }).then((ok) => {
        if (ok || tries >= 30) clearInterval(t);
      });
    }, 150);
  }

  // Mantenerlo cuando el tema re-renderiza el drawer o cambia el carrito
  function observeDrawerForRerender() {
    let obs;
    const attach = () => {
      const drawer = findDrawer();
      if (!drawer) return false;

      if (obs) obs.disconnect();
      obs = new MutationObserver(() => {
        // Cada vez que Breath re-renderiza, sincronizamos contra cart.js
        // (con delay pequeño para no pelear)
        setTimeout(() => syncWithRetries({ force: true }), 200);
      });
      obs.observe(drawer, { childList: true, subtree: true });
      return true;
    };

    let tries = 0;
    const t = setInterval(() => {
      tries++;
      if (attach() || tries >= 40) clearInterval(t);
    }, 150);
  }

  // ---------- after reload ----------
  if (sessionStorage.getItem(FLAG_OPEN) === '1') {
    sessionStorage.removeItem(FLAG_OPEN);

    setTimeout(() => {
      openDrawer();
      syncWithRetries({ force: true });
      observeDrawerForRerender();
    }, 350);
  } else {
    observeDrawerForRerender();
  }

  // ---------- bundle add flow ----------
  let inFlight = false;

  document.addEventListener(
    'click',
    async (e) => {
      if (!isBundlePage()) return;

      const btn = e.target.closest('button');
      if (!btn) return;

      const isAtc = btn.matches('button[name="add"][type="submit"][id^="x-atc-button-"]');
      if (!isAtc) return;

      if (inFlight) return;
      inFlight = true;

      // Guardar ahorro "temporal" del widget
      const savings = extractSavingsFromWidget();

      // Espera a que el add se complete
      await sleep(1100);

      try {
        const cart = await getCart();
        const bundles = getBundlesFromCart(cart);

        // Si hay bundles, asignamos el ahorro a TODOS los bundles que haya ahora mismo
        // (normalmente será 1; si hay varios, es el caso raro que mencionas)
        if (bundles.length > 0 && savings) {
          const map = loadSavingsMap();
          for (const b of bundles) {
            map[b.bundleId] = savings;
          }
          saveSavingsMap(map);
        }

        if (bundles.length > 0) {
          sessionStorage.setItem(FLAG_OPEN, '1');
          window.location.reload();
          return;
        }
      } catch (err) {
        // fallback: recargar igualmente
        sessionStorage.setItem(FLAG_OPEN, '1');
        window.location.reload();
        return;
      } finally {
        inFlight = false;
      }
    },
    true
  );
})();